import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const CircleAnimateIcon: FC<Props> = (props) => {
  return (
    <svg
      width="85"
      height="85"
      viewBox="0 0 85 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="relative"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="circle icon">
      {/* <title>circle icon</title> */}
      <g filter="url(#filter0_b_58_15010)">
        <ellipse
          cx="42"
          cy="42"
          rx="42"
          ry="42"
          fill="url(#paint0_radial_58_15010)"
        />
        <path
          d="M82 42C82 63.9977 64.094 81.8827 42 81.8827C19.906 81.8827 2 63.9977 2 42C2 19.885 19.906 2 42 2C64.094 2 82 19.885 82 42Z"
          stroke="#4E4E4E"
          strokeWidth="4"
        />
      </g>
      <path
        d="M 42 2 a 40 40 0 0 0 0 80"
        fill="none"
        stroke="white"
        strokeLinecap="round"
        strokeWidth="4"
        pathLength={100}
        className="dashed-spinner-anim"
      />
      <path
        d="M 42 82 a 40 40 10 0 0 0 -80"
        fill="none"
        stroke="white"
        strokeLinecap="round"
        strokeWidth="4"
        pathLength={100}
        className="dashed-spinner-anim"
      />
      <defs>
        <filter
          id="filter0_b_58_15010"
          x="-5"
          y="-5"
          width="94"
          height="93.8827"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_58_15010"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_58_15010"
            result="shape"
          />
        </filter>

        <radialGradient
          id="paint0_radial_58_15010"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(42 42) rotate(90) scale(42 42)"
        >
          <stop stopColor="#1F1F1F" />
          <stop offset="1" stopColor="#1F1F1F" stopOpacity="0.9" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default CircleAnimateIcon;
